import { AudiogramGenerateRequestDto } from '@app/modules/fragments/fragment.types';
import { BaseAPIClient } from '@mi-front/core';

export const FragmentsAPI = {
  configUpdate(this: BaseAPIClient, stationId: string, data: unknown) {
    return this.put(`/fragments/config/${stationId}`, data);
  },

  audiogramGenerate(this: BaseAPIClient, id: string, data: AudiogramGenerateRequestDto) {
    return this.post(`/fragments/${id}/audiogram/generate`, data);
  },

  audiogramSocialExport(this: BaseAPIClient, fragmentId: string, platform: string, data: object) {
    return this.post(`/fragments/${fragmentId}/audiogram/social-export/${platform}`, data);
  },

  /** Resolves the generated audiogram media URL for a fragment variant. */
  audiogramMediaUrl(this: BaseAPIClient, fragmentId: string, variant?: string): Promise<string> {
    return this.get<{ url: string }>(`/fragments/${fragmentId}/audiogram/media-url`, {
      params: { variant },
    }).then((d) => d.url);
  },
};
